import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "ghost";
type Size = "md" | "sm";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
}

/**
 * The mock's two button styles: solid crimson for the one primary action on a screen, and a ghost outline for
 * everything else. Disabled dims rather than greys so the label stays readable.
 */
const variants: Record<Variant, string> = {
  primary: "bg-accent text-on-accent hover:bg-accent-pressed border-transparent",
  ghost: "bg-transparent text-accent border-border hover:bg-accent-tint hover:border-accent",
};

const sizes: Record<Size, string> = {
  md: "min-h-11 px-[22px] text-[14.5px] rounded-[var(--radius-control)]",
  sm: "min-h-9 px-[15px] text-[13px] rounded-[9px]",
};

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 border-[1.5px] font-bold transition-[background-color,transform]
        active:translate-y-px disabled:cursor-not-allowed disabled:opacity-45 ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    />
  );
}
